import { TryAgainMessage } from '@src/components/shared/try-again-message/try-again-message';

export const TryAgainWidgetMessage = () => {

    return <TryAgainMessage message={<div>
        <div><b>Data unavailable at the moment</b></div>
        <span>Refresh to try again</span>
    </div>} />;
};